<div class="main-wrapper">
  <div class="page-wrapper full-page vh-100">
    <div class="page-content d-flex align-items-center justify-content-center vh-100">
      <div class="row w-100 mx-0 auth-page">
        @if(type != 503){
        <div class="col-md-8 col-xl-6 mx-auto d-flex flex-column align-items-center">
          <img src="../../../../assets/other/404.svg" class="img-fluid mb-2" alt="404">
          <h1 class="fw-bolder mb-22 mt-2 tx-80 text-muted">{{type}}</h1>
          <h4 class="mb-2">{{title}}</h4>
          <h6 class="text-muted mb-3 text-center" [innerHTML]="desc"></h6>
          <a (click)="goToHome()" class="btn btn-primary">{{'NOT_FOUND_PAGE.BACK_TO_HOME' | translate}}</a>
        </div>
        }
        <!-- 503 -->
        @if(type == 503){
        <div class="col-md-8 col-xl-6 mx-auto d-flex flex-column align-items-center">
          <h2 class="mb-2">{{title | translate}}</h2>
          <img style="width: 350px;height: auto;" src="../../../../assets/other/under-maintanence.png"
            class="img-fluid mb-2" alt="404">
          <h4 class="text-muted my-3 text-center" [innerHTML]="desc"></h4>
          @if(type == 503){
          <a (click)="goToHome()" class="btn btn-primary">{{'NOT_FOUND_PAGE.BACK_TO_HOME' |
            translate}}</a>
          }
        </div>
        }
      </div>

    </div>
  </div>
</div>
